import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { Contacts } from '@components/templates/contacts';

export function ContactsPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('contacts-page.metatags.title'),
        description: t('contacts-page.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.contacts,
        index: true,
    });

    return <Contacts />;
}
